@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.RemoveableChip {
  cursor: pointer;
  display: grid;
  grid-template-columns: auto auto;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  background-color: $theme-color-background;
  border: 1px solid $theme-color-dropdown-border-color;
  width: auto;
  max-width: max-content;

  &.hover {
    background: $theme-color-dark-secondary-button-hover;
  }

  &.focus {
    background-color: $theme-color-checkbox-disabled-checked-background;
  }
}

button.RemoveableChip {
  justify-content: center;
  align-items: end;
  border-radius: 4px;
  column-gap: 0;
  background-color: $theme-color-background;
  border: 0;

  &.singleLabelButton {
    padding: 2px 6px;
  }

  &.labelButton {
    padding: 2px 2px 2px 6px;
  }

  &.iconButton {
    padding: 3px 6px 3px 2px;
  }

  &.hover {
    background: $theme-color-dark-secondary-button-hover;
  }

  &.focus {
    background-color: $theme-color-checkbox-disabled-checked-background;
  }
}
